<template>
  <div>
    <h1>Basket</h1>
    <div class="loader-container">
      <div v-if="basket && !basket.count">Basket empty</div>
      <div v-if="basket && basket.count" class="basket">
        <BasketItemProductGroup
          v-for="basketItemProductGroup in basket.itemProductGroups"
          :key="basketItemProductGroup.id"
          :basket-item-product-group="basketItemProductGroup"
        />
        <BasketAdjustment
          v-for="adjustment in basket.adjustments"
          :key="adjustment.id"
          :basket-adjustment="adjustment"
        />
        <div class="basket-group">
          <h2>
            <div class="basket-text">Total</div>
            <div class="basket-cost">
              <div class="basket-price">
                <span class="basket-amount">£{{ basket.total.toFixed(2) }}</span>
              </div>
            </div>
          </h2>
        </div>
        <div class="basket-group">
          <BasketPackage
            v-for="basketPackage in basket.packages"
            :key="basketPackage.id"
            :basket-package="basketPackage"
          />
        </div>
      </div>

      <button
        v-if="basket && basket.count"
        class="ui-button"
        type="button"
        @click="checkout"
      >Checkout</button>
      <ModalIFrame :visible="showModal" :url="checkoutUrl" @close="showModal = false" />
      <Loader :loading="!basket || addingToBasket" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { authComputed } from '../vuex/helpers.js';
import Service from '@/services/Service.js';
import BasketItemProductGroup from '@/components/BasketItemProductGroup.vue';
import BasketAdjustment from '@/components/BasketAdjustment.vue';
import BasketPackage from '@/components/BasketPackage.vue';
import ModalIFrame from '@/components/ModalIFrame.vue';
import Loader from '@/components/Loader.vue';

export default {
  components: {
    BasketItemProductGroup,
    BasketAdjustment,
    BasketPackage,
    ModalIFrame,
    Loader
  },
  data: function() {
    return {
      showModal: false,
      addingToBasket: false
    };
  },
  computed: {
    checkoutUrl() {
      return (
        process.env.VUE_APP_SALES_URL +
        '/basket/basket.aspx?sessionid=' +
        this.session.id +
        '&theme=Stark_V'
      );
    },
    ...authComputed,
    ...mapState(['session']),
    ...mapState(['basket'])
  },
  methods: {
    checkout() {
      this.showModal = true;
    }
  }
};
</script>
